import globals from '../globals'

export default globals.messages
